
import api from "../../services/api";
const namespaced = true;

const state = {
    mails: [],
    interface: {},
    userType: null,
    loaded: false
};

const getters = {
    getLoadingStatus: state => state.loaded,
    getMails: state => state.mails, 
    getInterface: state => state.interface,
    getUserType: state => state.userType
};

const actions = {
    async fetchUserSettings ({ commit }) {
        commit("setLoadingStatus", false);
        let userSettings;
        const userSettingsPromise = api.getUserSettings();
        userSettings = await userSettingsPromise;
        commit("setUserSettings", userSettings);
        commit("setLoadingStatus", true);
    },
    async saveUserSettings({commit}, settings){
        commit("setLoadingStatus", false);
        const response = await api.saveUserSettings(settings);
        const userSettings = await api.getUserSettings();
        commit("setUserSettings", userSettings);
        console.log(response);
        commit("setLoadingStatus", true);        
    }
};

const mutations = {
    setUserSettings: (state, settings) => (state.mails = settings.mails, state.interface = settings.interface, state.userType = settings.type),
    setLoadingStatus: (state, status) => (state.loaded = status)
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
